<template>
    <div>
<!--      
    <div
      class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
    >
-->
    <div
      id="reg"
      class="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
    >
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <!-- <img
          class="mx-auto h-12 w-auto"
          src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
          alt="Workflow"
        /> -->
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {{ title }}
        </h2>
      </div>

        <!--
        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
                На данный момент регистрация не доступна. Следите за новостями на сайте фонда.
            </div>
        </div>
        -->





        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <ErrorMessage v-if="error" :error="error" />
                <form v-if="!success" @submit.prevent="submit" class="space-y-6">

                    <div>
                        <label for="name" class="block text-sm font-medium text-gray-700">Имя:</label>
                        <div class="mt-1">
                            <input v-model="form.name" id="name" name="name" type="text" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                        </div>
                    </div>


                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">Email:</label>
                        <div class="mt-1">
                            <input v-model="form.email" id="email" name="email" type="email" autocomplete="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                        </div>
                    </div>

                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-700">Пароль:</label>
                        <div class="mt-1">
                            <input v-model="form.password" id="password" name="password" type="password" autocomplete="current-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                        </div>
                    </div>
                    <div>
                        <label for="password2" class="block text-sm font-medium text-gray-700">Подтвердите пароль:</label>
                        <div class="mt-1">
                            <input v-model="form.password2" id="password2" name="password2" type="password" autocomplete="current-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                        </div>
                    </div>


                    <div>
                        <div class="mt-1">
                            <input v-model="form.is_med" id="is_med" name="is_med" type="checkbox" class="" />
                            &nbsp;
                            <label for="is_med" class="text-sm font-medium text-gray-700">Я являюсь действующим медицинским работником или студентом медицинского образовательного учреждения.</label>
                            
                        </div>
                    </div>

                    <div>
                        <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Вход</button>
                    </div>

                </form>

                <div v-if="success" class="flex items-center text-green-700">
                    <span>Регистрация завершена! Теперь вы можете войти, используя ваш Email.</span>
                </div>

                <div class="text-right mt-8">
                    <router-link style="color: blue" :to="{ name: 'signin' }">Вход</router-link>
                </div>

            </div>
        </div>

    </div>

<!--
        <form @submit.prevent="submit">
            <div class="form-group">
                <label for="name" class="col-form-label">Name</label>
                <input type="text" name="name" id="name" v-model="form.name" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.name">
                    {{ errors.validation.name[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="email" class="col-form-label">Email</label>
                <input type="text" name="email" id="email" v-model="form.email" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.email">
                    {{ errors.validation.email[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="password" class="col-form-label">Password</label>
                <input type="password" name="password" id="password" v-model="form.password" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.password">
                    {{ errors.validation.password[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="password2" class="col-form-label">Password confirm</label>
                <input type="password" name="password2" id="password2" v-model="form.password2" class="form-control">
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">
                    Register
                </button>
            </div>
            <div class="alert alert-danger" v-if="errors.register">
                {{ errors.register }}
            </div>
            <div class="alert alert-success" v-if="success">
                {{ success }}
            </div>
        </form>
-->

    </div>
</template>

<script>

import axios from 'axios'
import ErrorMessage from "@/components/ErrorMessage";
export default {
    name: 'register',
    components: {
        ErrorMessage,
    },
    data() {
        return {
            form: {
                /*
                name: 'vasya',
                email: 'vasya@vasya.vasya',
                password: 'vasyavasya',
                password2: 'vasyavasya',
                */
                name: '',
                email: '',
                password: '',
                password2: '',
                is_med: false,
            },
            errors: {register: '', validation: {}},
            error: '',
            success: '',
            title: 'Регистрация'
        }
    },
    mounted() 
    {
        // это для перехода по "якорю":
        var section=this.$router.currentRoute.hash.replace("#", "");
        if (section) {
            this.$nextTick(()=> window.document.getElementById(section).scrollIntoView());
        }       
    },
    methods: {
        async submit() {
            this.errors.validation = {}
            this.errors.register = ''
            this.error = ""
            this.success = ''
            this.success = false;
            if (this.form.password != this.form.password2) {
                this.errors.validation = { password: ['Пароли не совпадают!'] }
                this.error = "Пароли не совпадают!"
                return
            }
            try {
                let response = await axios.post('register', this.form);
                if (response.status == 200) {
                    //this.success = 'Пользователь (email: ' + this.form.email + ') зарегистрирован!'
                    this.success = true
                    this.form.email = ''
                    this.form.name = ''
                    this.form.password = ''
                    this.form.password2 = ''
                    this.form.is_med = false
                }
            }
            catch (e) {
                this.error = "Ошибка при регистрации. Возможно, пользователь с таким Email уже зарегистрирован.";
                /*
                if (e.response.status == 422) {
                    this.errors.validation = e.response.data.errors
                }
                else if (e.response.status == 520) {
                    this.errors.register = "Ошибка при регистрации пользователя."
                }
                else {
                    this.errors.register = "Неизвестная ошибка при регистрации пользователя."
                }
                */
            }
        },
    },
}
</script>